export default "__VITE_ASSET__c8688499__"